export default __webpack_public_path__ + "static/media/waiting-payment.f23cd837.svg";